<template>
  <v-container class="authentication-container">
    <v-app-bar v-if="!mdAndUp" class="authentication-container__mobile-bar pl-2">
      <app-logo class="mb-2" />
    </v-app-bar>
    <v-row v-if="mdAndUp" justify="center" class="authentication-container__logo">
      <v-col cols="12" class="text-center pt-0">
        <app-logo />
      </v-col>
    </v-row>
    <teleport to=".v-application">
      <div v-if="user && !isEmbedded" class="user-block-container">
        <v-row align="center">
          <v-col>
            <user-block>
              <v-avatar color="primary" class="user-block__avatar" size="42">
                {{ user?.firstName.charAt(0) + user?.lastName.charAt(0) }}
              </v-avatar>
            </user-block>
          </v-col>
        </v-row>
      </div>
    </teleport>
    <v-row align-content="center" justify="center" class="authentication-container__content">
      <v-col cols="auto" class="d-flex align-center">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useDisplay } from 'vuetify'

import { useAppStore } from '@/stores/app'

import UserBlock from '@/components/UserBlock.vue'
import { isEmbedded } from '@/api/client'
import AppLogo from '@/components/AppLogo.vue'

const appStore = useAppStore()
const { mdAndUp } = useDisplay()

const user = computed(() => {
  return appStore.user
})
</script>

<style lang="scss" scoped>
.authentication-container {
  align-items: flex-start !important;
  &__mobile-bar {
    .v-toolbar__content {
      justify-content: center !important;
    }
  }
  &__logo,
  &__content {
    width: 100%;
  }
  &__content {
    height: 85vh;
    margin: auto;
    > .v-col {
      height: 100%;
    }
  }
}
.user-block-container {
  display: flex;
  position: absolute !important;
  right: 10px;
  top: 8px;
  z-index: 1010 !important; // Needs to be greater than app-bar in mobile view
}
</style>
@/composables/useTheme
